import React from 'react';

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const Wordmark = ({ size = 20 }) => (
  <span className="wordmark">
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="16" rx="3" fill="none" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="9" cy="11" r="2.25" fill="none" stroke="currentColor" strokeWidth="1.75" />
      <path d="M5.5 16.5c.7-1.6 2-2.5 3.5-2.5s2.8.9 3.5 2.5" {...base} />
      <path d="M15.5 9.5h3M15.5 13h3" {...base} />
    </svg>
    Rapid Contact
  </span>
);

export const CopyIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="9" y="9" width="12" height="12" rx="2" {...base} />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" {...base} />
  </svg>
);

export const CheckIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" {...base} />
  </svg>
);

export const NfcIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6 8.5a7 7 0 0 1 12 0" {...base} />
    <path d="M8.5 12a4 4 0 0 1 7 0" {...base} />
    <circle cx="12" cy="15.5" r="1.25" fill="currentColor" stroke="none" />
  </svg>
);

export const PencilIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" {...base} />
  </svg>
);

export const TrashIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" {...base} />
  </svg>
);

export const PlusIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 5v14M5 12h14" {...base} />
  </svg>
);

export const CardIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="2.5" y="4" width="19" height="16" rx="3" {...base} />
    <circle cx="9" cy="11" r="2.25" {...base} />
    <path d="M5.5 16.5c.7-1.6 2-2.5 3.5-2.5s2.8.9 3.5 2.5M15.5 9.5h3M15.5 13h3" {...base} />
  </svg>
);
